export const SET_SELECTED_MENU_TYPE = '[DASHBOARD][FETCH] set selected menu type';
export const SET_DASHBOARD_TYPE = '[DASHBOARD][SET][TYPE] setting dashboard type';
export const RESET_SELECTED_CHART_DATA = '[DASHBOARD][RESET] reset selected chart data';

const json = {
  SET_SELECTED_MENU_TYPE,
  RESET_SELECTED_CHART_DATA,
};

export default json;
